import React from "react";
import "../../../Styles/components/form-controls.scss";

export default function FormInput({
  as = "input",
  className = "",
  disabled = false,
  error = "",
  inputMode,
  label = "",
  onChange,
  prefix = null,
  type = "text",
  value = "",
  ...props
}) {
  const Component = as === "textarea" ? "textarea" : "input";

  return (
    <div className={["form-field", className].filter(Boolean).join(" ")}>
      {label ? <label className="form-field__label">{label}</label> : null}
      <div className={`form-field__control-wrap ${prefix ? "has-prefix" : ""}`}>
        {prefix ? <span className="form-field__prefix">{prefix}</span> : null}
        <Component
          {...(Component === "input" ? { type } : {})}
          value={value}
          onChange={onChange}
          disabled={disabled}
          inputMode={inputMode}
          className={`form-field__control ${error ? "has-error" : ""}`}
          {...props}
        />
      </div>
      {error ? <div className="form-field__error">{error}</div> : null}
    </div>
  );
}
